export enum Origin {
  Manager = 'admin',
  AdminSmile = 'admin-smile',
  Aggregator = 'aggregator',
  Android = 'android',
  Marketplace = 'eversport',
  Interface = 'interface',
  Ios = 'ios',
  Widget = 'widget',
  Migration = 'migration',
  ProviderApi = 'provider-api',
}

const marketplaceOrigins = new Set([Origin.Android, Origin.Marketplace, Origin.Ios])

export function isMarketplaceOrigin(origin: Origin): boolean {
  return marketplaceOrigins.has(origin)
}

export function mapStringToOrigin(input?: string | null): Origin {
  switch (input) {
    case 'android':
      return Origin.Android
    case 'ios':
      return Origin.Ios
    case 'eversport':
    case 'eversports':
    case 'marketplace':
      return Origin.Marketplace
    case 'admin':
    case 'manager':
      return Origin.Manager
    case 'widget':
      return Origin.Widget
    case 'aggregator':
      return Origin.Aggregator
    case 'provider-api':
      return Origin.ProviderApi
    default:
      return Origin.Marketplace
  }
}
